import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './index.scss'
import __i18n from "../../../intl/__i18n";
import {getFormattedDate} from '@utils';


function SubscriptionsCountChart({data}) {
  return (
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            text: __i18n("Subscriptions Count Report")
          },
          subtitle: {
            text: ""
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter: function () {
                return getFormattedDate({date : this.value, showTime: false})
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Count")
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px"></span><table>',
            pointFormat: `<tr><td style="color:{series.color};padding:0">${ __i18n("Toman")}: </td>` +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: __i18n("Count of Subscriptions"),
            data: data.map(item => [item.date_time, item.total]),
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              align: 'right',
              // format: '{point.y:.1f}', // one decimal
              y: 10, // 10 pixels down from the top
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          }]
        }}
      />
    </div>
  )
}

export default SubscriptionsCountChart;

